import { Validators } from '@biteinc/common';
import type { Schema } from '@biteinc/common';
import { CountryCode } from '@biteinc/enums';

export const createSiteGuidedSchema: Schema.Model = {
  displayName: 'site',
  type: 'object',
  fields: {
    name: {
      type: 'keyString',
      required: true,
    },
    storeNumber: {
      type: 'keyString',
      displayName: 'Store Number',
      validationRegex: Validators.siteStoreNumberRegexString,
      tooltip: {
        text: 'Allowed characters: uppercase letters, numbers, and dashes.',
      },
    },
    countryCode: {
      displayName: 'Country',
      type: 'stringEnum',
      enum: CountryCode,
      required: true,
      defaultValue: CountryCode.UnitedStates,
      ui: 'radiolist',
    },
    postalCode: {
      displayName: 'Postal Code',
      type: 'keyString',
      required: true,
    },
    biteOnly: {
      type: 'bool',
      displayName: 'Bite-Only',
      biteOnly: true,
    },
    fulfillmentStations: {
      type: 'array',
      elementType: 'object',
      ui: 'accordion',
      uiSubtype: 'FulfillmentStations',
      displayName: 'Fulfillment stations',
      tooltip: {
        text: 'Only applies to Fresh KDS.',
      },
      fields: {
        _id: {
          type: 'mongoId',
          isHidden: true,
        },
        name: {
          type: 'shortString',
          displayName: 'Name',
          required: true,
        },
        isEnabled: {
          type: 'bool',
          displayName: 'Enabled',
          defaultValue: true,
        },
      },
    },
  },
};
